module.exports = __webpack_public_path__ + "img/bioinformatica.243de2f1.jpg";